import {FilterType} from "@studyportals/omnisearch-interfaces";
import {FilterMapper} from "@app/routing/mappers/FilterMapper";
import {areasAll} from "@studyportals/static-domain-data/areas/areas";
import {areaGetPath} from "@studyportals/static-domain-data/areas/area-get-path";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

type AreaRecord = {
	id: number | string;
	name: string;
	countryIso?: string;
	countryId?: string;
};

export class AreaFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.AREA;
	public isMultiSelect = true;
	private static instance: AreaFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [];
	private countryAreas : {id: string, countryIso?: string, countryId?: string} [] = [];

	public static getInstance(): AreaFilterMapper {
		if (!AreaFilterMapper.instance) {
			AreaFilterMapper.instance = new AreaFilterMapper();
		}
		return AreaFilterMapper.instance;
	}

	private constructor() {
		super();

		const typedAreas = areasAll as unknown as AreaRecord[];

		for (const area of typedAreas) {
			const virtualPath = areaGetPath(area.id.toString())?.split('/')[1];

			if (virtualPath) {
				this.values.push({
					id: area.id.toString(),
					virtualPath,
					name: area.name
				});
				this.countryAreas.push({
					id: area.id.toString(),
					countryIso: area.countryIso,
					countryId: area.countryId
				});
			}
		}
	}

	public getCountryIsoByAreaId(areaId: string): string | undefined {
		const countryArea = this.countryAreas.find((area) => area.id === areaId);

		return countryArea?.countryIso;
	}
}
